import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import ProductCard from '../../../components/ui/ProductCard';

function SimilarProduct({ currentProduct }) {
  const { products } = useSelector((state) => state.listProduct);

  const similarProducts = useMemo(() => {
    if (!currentProduct || !products) return [];
    return products
      .filter(
        (item) =>
          item.category === currentProduct.category &&
          item._id !== currentProduct._id
      )
      .slice(0, 12);
  }, [currentProduct, products]);

  if (similarProducts.length === 0) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
      <div className="bg-[#9EAD8C] rounded-xl shadow-sm p-2 sm:p-6">
        <div className="flex items-center justify-between">
          <p className="text-base sm:text-lg lg:text-xl font-bold text-gray-800 m-2">
            محصولات <span className="text-text1">مرتبط</span>
          </p>
          <span className="text-xs m-2 text-gray-400 bg-gray-100 px-2 py-0.5 rounded-full">
            {similarProducts.length} محصول
          </span>
        </div>
        <Swiper
          dir="rtl"
          modules={[Navigation, Pagination]}
          navigation
          pagination={{ clickable: true, dynamicBullets: true }}
          className="w-full !pb-12"
          spaceBetween={12}
          slidesPerView={1.2}
          breakpoints={{
            0: { spaceBetween: 10, slidesPerView: 1.2 },
            320: { spaceBetween: 10, slidesPerView: 1.3 },
            380: { spaceBetween: 10, slidesPerView: 1.5 },
            460: { spaceBetween: 12, slidesPerView: 2 },
            640: { spaceBetween: 14, slidesPerView: 2.4 },
            768: { spaceBetween: 16, slidesPerView: 3 },
            900: { spaceBetween: 16, slidesPerView: 3.4 },
            1024: { spaceBetween: 18, slidesPerView: 4 },
            1280: { spaceBetween: 20, slidesPerView: 4.8 },
          }}
        >
          {similarProducts.map((product) => (
            <SwiperSlide key={product._id} className="!h-auto">
              <div className="px-1 py-2">
                <ProductCard {...product} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default SimilarProduct;